module.exports = __webpack_public_path__ + "img/El_Salvador.0a63c45d.png";